(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Tapetfix – mega menu hover behaviour (desktop) */
  document.addEventListener('DOMContentLoaded', function() {
    var desktopBreakpoint = 990;
    var triggers = document.querySelectorAll('.header-menu-item[data-mega-trigger]');
    var panels = document.querySelectorAll('.kf-mega-menu[data-mega-panel]');
    var activeHandle = null;
    var hideTimeout;

    if (!triggers.length || !panels.length) return;

    function getPanel(handle) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].dataset.megaPanel === handle) return panels[i];
      }
      return null;
    }

    function openPanel(handle) {
      if (window.innerWidth < desktopBreakpoint) return;
      if (activeHandle === handle) return;

      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.remove('kf-mega-menu--active');
      }

      var panel = getPanel(handle);
      if (panel) {
        panel.classList.add('kf-mega-menu--active');
        activeHandle = handle;
      }
    }

    function closePanel() {
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.remove('kf-mega-menu--active');
      }
      activeHandle = null;
    }

    function scheduleClose() {
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(closePanel, 120);
    }

    function cancelClose() {
      clearTimeout(hideTimeout);
    }

    triggers.forEach(function(trigger) {
      var handle = trigger.dataset.megaTrigger;

      trigger.addEventListener('mouseenter', function() {
        cancelClose();
        openPanel(handle);
      });

      trigger.addEventListener('mouseleave', scheduleClose);
    });

    panels.forEach(function(panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    });

    window.addEventListener('resize', function() {
      if (window.innerWidth < desktopBreakpoint) {
        closePanel();
      }
    });
  });


  /* Topbar rotator (Hovia-style) */
  document.addEventListener('DOMContentLoaded', function () {
    var rotator = document.querySelector('.tf-topbar__rotator');
    if (!rotator) return;

    var items = rotator.querySelectorAll('.tf-rot');
    if (!items || items.length < 2) return;

    var i = 0;
    for (var k = 0; k < items.length; k++) {
      if (items[k].classList.contains('is-active')) { i = k; break; }
    }

    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 2600); // 3.5 sek
  });





  } catch(e) { console.error(e); }
})();
})();
